import { render, staticRenderFns } from "./DpTenantAgreement.vue?vue&type=template&id=52c96650&scoped=true&"
import script from "./DpTenantAgreement.vue?vue&type=script&lang=js&"
export * from "./DpTenantAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c96650",
  null
  
)

export default component.exports